import React, { ReactElement } from 'react';
import SuspenseLoadPage from '../components/Auth/SuspenceLoadPage';

const TradingCom = React.lazy(() => import('../components/Trade'));

function Trading(): ReactElement {
  return (
    <SuspenseLoadPage>
      <TradingCom />
    </SuspenseLoadPage>
  );
}

export default Trading;
